/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner } from './FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner';
import {
    FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInnerFromJSON,
    FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInnerFromJSONTyped,
    FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInnerToJSON,
    FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInnerToJSONTyped,
} from './FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner';

/**
 * 
 * @export
 * @interface FindAllExecutionsAvailableByFacilityId200ResponseDataInner
 */
export interface FindAllExecutionsAvailableByFacilityId200ResponseDataInner {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    facility_id: string;
    /**
     * 
     */
    executions_available: number;
    /**
     * 
     */
    createdAt: string;
    /**
     * 
     */
    updatedAt: string;
    /**
     * 
     */
    reset_enabled: boolean;
    /**
     * 
     */
    last_reset_at: string;
    /**
     * 
     */
    periodic_executions_limit: number;
    /**
     * 
     */
    executions_history?: Array<FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner>;
    /**
     * 
     */
    no_analysis_facility: boolean;
}

/**
 * Check if a given object implements the FindAllExecutionsAvailableByFacilityId200ResponseDataInner interface.
 */
export function instanceOfFindAllExecutionsAvailableByFacilityId200ResponseDataInner(value: object): value is FindAllExecutionsAvailableByFacilityId200ResponseDataInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('executions_available' in value) || value['executions_available'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('reset_enabled' in value) || value['reset_enabled'] === undefined) return false;
    if (!('last_reset_at' in value) || value['last_reset_at'] === undefined) return false;
    if (!('periodic_executions_limit' in value) || value['periodic_executions_limit'] === undefined) return false;
    if (!('no_analysis_facility' in value) || value['no_analysis_facility'] === undefined) return false;
    return true;
}

export function FindAllExecutionsAvailableByFacilityId200ResponseDataInnerFromJSON(json: any): FindAllExecutionsAvailableByFacilityId200ResponseDataInner {
    return FindAllExecutionsAvailableByFacilityId200ResponseDataInnerFromJSONTyped(json, false);
}

export function FindAllExecutionsAvailableByFacilityId200ResponseDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllExecutionsAvailableByFacilityId200ResponseDataInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'facility_id': json['facility_id'],
        'executions_available': json['executions_available'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'reset_enabled': json['reset_enabled'],
        'last_reset_at': json['last_reset_at'],
        'periodic_executions_limit': json['periodic_executions_limit'],
        'executions_history': json['executions_history'] == null ? undefined : ((json['executions_history'] as Array<any>).map(FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInnerFromJSON)),
        'no_analysis_facility': json['no_analysis_facility'],
    };
}

export function FindAllExecutionsAvailableByFacilityId200ResponseDataInnerToJSON(json: any): FindAllExecutionsAvailableByFacilityId200ResponseDataInner {
    return FindAllExecutionsAvailableByFacilityId200ResponseDataInnerToJSONTyped(json, false);
}

export function FindAllExecutionsAvailableByFacilityId200ResponseDataInnerToJSONTyped(value?: FindAllExecutionsAvailableByFacilityId200ResponseDataInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'facility_id': value['facility_id'],
        'executions_available': value['executions_available'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'reset_enabled': value['reset_enabled'],
        'last_reset_at': value['last_reset_at'],
        'periodic_executions_limit': value['periodic_executions_limit'],
        'executions_history': value['executions_history'] == null ? undefined : ((value['executions_history'] as Array<any>).map(FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInnerToJSON)),
        'no_analysis_facility': value['no_analysis_facility'],
    };
}

